import styled from 'styled-components';

export const SSubscriptionBreadcrumbs = styled.div`
  .MuiBreadcrumbs-root {
    padding-top: 0;

    a.disabled {
      opacity: 0.4;
    }
  }
`;

export default SSubscriptionBreadcrumbs;
